"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasScreenSubject = exports.hasWorldSubject = exports.useCameraSubject = void 0;
const rxjs_1 = require("./rxjs");
const operators_1 = require("rxjs/operators");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const rxjs_2 = require("rxjs");
/**
 * Returns the camera subjects for a given array of video controllers

 * @param videoControllers Takes an observable array of videoControllers: Observable<IVideoController[]>
 */
function useCameraSubject(videoControllers) {
    const cameraSubjectsObservable = videoControllers.pipe((0, operators_1.switchMap)(controllers => {
        return (0, rxjs_2.combineLatest)(controllers.map(controller => controller.cameraSubject));
    }), (0, operators_1.distinctUntilChanged)((prev, curr) => prev === curr));
    const [cameraSubjects] = (0, rxjs_1.useObservable)(cameraSubjectsObservable);
    return cameraSubjects || [];
}
exports.useCameraSubject = useCameraSubject;
function hasWorldSubject(videoControllers) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useCameraSubject(videoControllers).includes(streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_WORLD);
}
exports.hasWorldSubject = hasWorldSubject;
function hasScreenSubject(videoControllers) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useCameraSubject(videoControllers).includes(streem_sdk_protobuf_1.CameraSubject.CAMERA_SUBJECT_SCREEN);
}
exports.hasScreenSubject = hasScreenSubject;
//# sourceMappingURL=use_camera_subject.js.map